import axiosClient from './axiosClient'

const moneyTypeApi = {
  find: (params) => {
    const url = '/money-type/find'
    return axiosClient.get(url, { params })
  },
  // Lấy tỷ giá mới nhất của một loại tiền tệ
  latestExchangeRate: (currency) => {
    const url = `/money-type/latest-exchange-rate/${currency}`
    return axiosClient.get(url)
  },

  create: (params) => {
    const url = '/money-type/create'
    return axiosClient.post(url, params)
  },

  update: (params) => {
    const url = `/money-type/update/${params.moneyTypeId}`
    return axiosClient.put(url, params)
  },

  delete: (params) => {
    const url = '/money-type/delete'
    return axiosClient.delete(url, {
      data: {
        moneyTypeIds: params,
      },
    })
  },
}

export default moneyTypeApi
